<div *ngIf="isLoading" class="min-h-[60vh]">
  <app-loading [text]="'Cargando datos de usuario'"></app-loading>
</div>
<div *ngIf="!isLoading" class="space-y-6">
  <div
    class="w-full rounded-lg p-6 border border-gray-200 flex flex-col space-y-4"
  >
    <div
      class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
    >
      <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <app-nav-button [route]="navRoute"></app-nav-button>
        <h2 class="text-md sm:text-xl font-medium">
          Oferta de empleo:<br />
          <span class="text-lg sm:text-xl font-bold">{{
            details.job_offer.title
          }}</span>
        </h2>
      </div>
      <div class="flex flex-wrap gap-3 items-center sm:gap-4">
        <span
          class="px-3 py-1 rounded-full text-white text-xs font-semibold"
          [ngClass]="{
            'bg-gray-400': details.statusProcess === 'Enviado',
            'bg-blue-500': details.statusProcess === 'Revisado',
            'bg-yellow-500': details.statusProcess === 'Preseleccionado',
            'bg-green-500': details.statusProcess === 'Seleccionado'
          }"
        >
          {{ getStatusLabel(details) }}
        </span>
        <button
          (click)="openConfirmModal(getNextAction(details))"
          [disabled]="details.statusProcess === 'Seleccionado'"
          class="px-4 py-2 border rounded-md text-xs sm:text-sm transition"
          [ngClass]="{
            'border-primary text-primary hover:bg-primary hover:text-white':
              details.statusProcess !== 'Seleccionado',
            'border-gray-400 text-gray-400 bg-gray-100 cursor-not-allowed':
              details.statusProcess === 'Seleccionado'
          }"
        >
          {{ getNextActionLabel(details) }}
        </button>
      </div>
    </div>
    <div
      class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-2 sm:mt-4"
    >
      <div class="flex items-center gap-4 flex-col sm:flex-row">
        <img
          [src]="userImage()"
          alt="Foto perfil"
          class="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover border border-gray-400"
        />
        <div class="flex flex-col items-center sm:items-start">
          <span
            class="text-base sm:text-lg font-semibold text-primary text-center sm:text-left"
            >{{ user.firstName }} {{ user.lastName }}</span
          >
          <div class="flex items-center gap-2 text-gray-600 text-xs sm:text-sm">
            <ng-icon
              name="featherMail"
              size="16"
              class="sm:w-[18px] sm:h-[18px]"
            ></ng-icon>
            <span>{{ user.email }}</span>
          </div>
        </div>
      </div>
      <a
        *ngIf="user?.urlPersonalFile; else noFile"
        [href]="user.urlPersonalFile"
        target="_blank"
        class="flex items-center justify-center px-3 sm:px-4 py-2 rounded-md bg-gray-800 text-white hover:bg-gray-700 gap-2 text-xs sm:text-sm shadow"
      >
        <span>Ver CV</span>
        <ng-icon
          name="featherExternalLink"
          size="16"
          class="sm:w-[20px] sm:h-[20px]"
        ></ng-icon>
      </a>
      <ng-template #noFile>
        <p class="text-gray-500 text-sm italic">No tiene un CV cargado</p>
      </ng-template>
    </div>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
    <div class="md:col-span-3 space-y-6">
      <div class="bg-white rounded-md p-6 border border-gray-200">
        <h2 class="text-lg sm:text-xl font-bold text-gray-800 mb-3">
          Presentación
        </h2>
        <p class="text-gray-600 text-sm sm:text-base">
          {{ user.personalInformation || "Sin presentación aún." }}
        </p>
      </div>
      <div class="bg-white rounded-md p-6 border border-gray-200">
        <h2 class="text-lg sm:text-xl font-bold text-gray-800 mb-3">
          Información personal
        </h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Departamento:</label
            >
            <p class="text-gray-600">{{ user.departament || "Vacío" }}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Provincia:</label
            >
            <p class="text-gray-600">{{ user.province || "Vacío" }}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Distrito:</label
            >
            <p class="text-gray-600 capitalize">
              {{ user.district || "Vacío" }}
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Dirección:</label
            >
            <p class="text-gray-600">{{ user.address || "Vacío" }}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Teléfono:</label
            >
            <p class="text-gray-600">{{ user.telfOne || "Vacío" }}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >DNI:</label
            >
            <p class="text-gray-600">
              {{ user.identificationDocument || "Vacío" }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="md:col-span-2 bg-white rounded-lg p-0 md:p-5 border border-gray-200"
    >
      <h2
        class="text-base sm:text-lg font-bold text-gray-800 mb-4 px-4 md:px-0 mt-5 md:mt-0"
      >
        Experiencias
      </h2>
      <div *ngIf="experiences?.length; else noExperiences">
        <div
          *ngFor="let exp of experiences"
          class="border-b px-4 border-gray-200 last:border-0 py-3"
        >
          <div>
            <p class="text-gray-800 font-medium wrap-break-words">
              {{ exp.companyName }}
            </p>
            <p
              class="text-primary font-semibold text-xs sm:text-sm wrap-break-words"
            >
              {{ exp.jobTitle.name }}
            </p>
          </div>
          <div class="flex flex-wrap gap-2 mt-1">
            <span
              class="px-2 py-0.5 text-xs bg-primary/10 text-primary rounded-full"
            >
              {{ exp.businessLine.description }}
            </span>
            <span
              class="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded-full"
            >
              {{ exp.area.name }}
            </span>
          </div>
          <p class="text-gray-600 text-xs mt-2 line-clamp-2">
            {{ exp.functionsDescription }}
          </p>
          <div class="flex items-center text-xs text-gray-500 mt-2 gap-1">
            <ng-icon name="heroCalendarDays" size="14"></ng-icon>
            <span
              >{{ exp.fromProperty | date : "MMM yyyy" }} -
              {{ exp.until | date : "MMM yyyy" }}</span
            >
          </div>
          <div
            *ngIf="exp.references?.length"
            class="mt-2 text-xs text-gray-600"
          >
            <p class="font-medium text-gray-700">Referencias:</p>
            <ul class="list-disc list-inside">
              <li *ngFor="let ref of exp.references">
                {{ ref.fullNameContact }}
                <span *ngIf="ref.telfContact">- {{ ref.telfContact }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ng-template #noExperiences>
        <div
          class="flex flex-col items-center justify-center text-center py-10 text-gray-500 px-4 md:px-0"
        >
          <ng-icon
            name="heroBriefcase"
            size="28"
            class="mb-3 text-gray-400"
          ></ng-icon>
          <p class="text-xs sm:text-sm font-medium">
            Este usuario no cuenta con experiencia laboral registrada.
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div
  *ngIf="confirmModalOpen"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas marcar como
      {{
        actionType === "revisar"
          ? "revisado"
          : actionType === "preseleccionar"
          ? "preseleccionado"
          : actionType === "seleccionar"
          ? "seleccionado"
          : "rechazar"
      }}
      al postulante?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeConfirmModal()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        (click)="confirmAction()"
        [text]="'Confirmar'"
        [loading]="isLoadingStatusProcess"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
